import { createContext } from "react";

const AccordionContext = createContext(null as any);

export default AccordionContext;
